// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__34Y-j","col":"styles_col__7uMks","fulfillmentStatus":"styles_fulfillmentStatus__2ENwM","emailCol":"styles_emailCol__1d54t"};